<template>
  <div>
    <div v-for="(score, index) in scores"
         v-if="index == ($route.params.index - 1)" class="viewer-container">
      <viewer v-if="score.manifest"
        class="viewer-outlet"
        :manifest="score.manifest">
      </viewer>
      <iframe v-else-if="score.url"
        :src="score.url"
        frameborder="0" >
      </iframe>
      <h2 v-else class="viewer__empty">Viewer for {{ score.title }} TK</h2>
    </div>
  </div>
</template>

<script>
//
// The purpose of this component is to de-couple the Viewer app and its
// sub-components from the application route structure. This is the last point
// where anything related to the Viewer should care about Chapters, Routes, or
// other publication-wide data. The Viewer component only accepts a manifest URL
// as a prop for maximum portability.
//
import { mapGetters } from 'vuex'
import Viewer from '@/components/viewer/App.vue'

export default {
  name: 'viewWrapper',
  components: { Viewer },
  computed: {
    ...mapGetters(['chapter']),
    scores () {
      return require('@/assets/data/' + this.chapter.shortname + '/score.yml')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/main.scss";
.viewer-container {
  background-color: $black-bis;
  height: calc(100vh - #{$navbar-height});
  margin-top: $navbar-height;
  overflow: hidden;

  iframe {
    height: calc(100vh - #{$navbar-height});
    width: 100%;
  }
}
.viewer__empty {
  align-items: center;
  color: #fff;
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/components/ViewWrapper.vue?07864b18